<template>
  <div class="profile-info">
    <div class="field">{{ field }}</div>
    <div class="value v-text-field">{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: String,
    },
    value: {
      type: String,
    },
  },
};
</script>

<style scoped>

.profile-info {
  margin: 1.5rem 0;
}

div.profile-info:first-of-type{
  display: none;
}
.field,
.edit-profile-button {
  font-size: 85%;
  color: var(--grey);
  margin: 0;
  text-transform: capitalize;
}

.value {
  max-width: 100%;
  background-color: #f1f1f1;
  border: 0.75px solid transparent;
  border-radius: 4px;
  color: var(--grey);
  padding: .625rem 10px;
}
</style>